import React from "react";
import { Link } from "react-router-dom";
import "../styles/Services.css";

import comprehensive from "../assets/services logos/comprehensive.jpg";
import Medical from '../assets/services logos/medical.jpg';
import Psychiatric from '../assets/services logos/psychiatric.jpg';
import SpecialSchool from '../assets/services logos/specialschool.jpg';
import Vocational from '../assets/services logos/vocational.jpg';
import Footer from "../components/Footer";
import DepartmentAssistants from "../components/DepartmentAssistants";

// Services Data
const servicesData = [
  {
    id: 1,
    title: "Comprehensive Therapeutic Services",
    description: "Integrated therapy programs customized for physical, mental, and emotional recovery.",
    image: comprehensive,
    path: "/services/Comprehensive-Therapetic-Services",
  },
  {
    id: 2,
    title: "Medical Rehabilitation In-Patient Services",
    description: "24/7 monitored care with expert doctors and evidence-based recovery plans.",
    image: Medical,
    path: "/services/medical-rehabilitation",
  },
  {
    id: 3,
    title: "Psychiatric Rehabilitation In-Patient Services",
    description: "Structured inpatient support for individuals with chronic psychiatric conditions.",
    image: Psychiatric,
    path: "/services/Psychiatric-Rehabilation",
  },
  {
    id: 4,
    title: "Special School for Neuro Developmental Disorders",
    description: "Inclusive education for children with autism, ADHD, and related conditions.",
    image: SpecialSchool,
    path: "/services/Special-School",
  },
  {
    id: 5,
    title: "Vocational Rehabilitation & Adult Living Support",
    description: "Skill-building and adaptive living programs for independent adult life.",
    image: Vocational,
    path: "/services/Ocational-Rehabilation",
  },
];

const ServicesPage = () => {
  return (
    <div>
      <section className="home-services-section">
              <h1 className="home-services-heading">Our Specialized Services</h1>
              <p className="home-services-subtitle">
                Empowering recovery through expert-led, personalized care that transforms lives.
              </p>
      
              <div className="home-services-container">
                {servicesData.map((service) => (
                  <div key={service.id} className="home-service-card">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="home-service-image"
                    />
                    <div className="home-service-content">
                      <h2 className="home-service-title">{service.title}</h2>
                      {service.description && (
                        <p className="home-service-description">{service.description}</p>
                      )}
                      <Link to={service.path} className="know-more-btn">
                        Know More <i className="fa-solid fa-arrow-right-long"></i>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <DepartmentAssistants />

      <Footer />
    </div>
  );
};

export default ServicesPage;
